/*
 * Media wiring for the hologram-lore-altar overlays (user request, 2026-09-07).
 *
 * Each `#screen-lore-<id>` block in index.html is a self-contained parchment.
 * Some embed a video (an `<iframe data-src=…>`), some are text only — this
 * module handles either. Nothing off-site loads until the overlay is first
 * opened; every iframe is blanked when it closes so playback / audio /
 * buffering all stop.
 *
 * 2026-09-11: a lore screen can now carry more than one video (the
 * crashed-UFO altar has a muted autoplaying short plus a muted, click-to-play
 * horizontal video). Both start muted and unmute through YouTube's own player
 * controls (`controls=1` in the iframe's query string) — no extra JS needed
 * here for that; this module still just promotes/blanks iframes generically.
 *
 * `Game` drives visibility through `GameState.LORE`; this module only manages
 * the iframes. Kept out of screens.js so that file stays a pure show/hide
 * controller (matching src/ui/scroll.js for the temple altar).
 */

const BLANK = "about:blank";

/**
 * Overlay `<id>` opened: promote every lazy iframe inside it to its real src.
 * No-op for a text-only panel.
 * @param {string} screen the `<id>` part of `#screen-lore-<id>`
 */
export function startLoreMedia(screen) {
  const root = document.getElementById(`screen-lore-${screen}`);
  if (!root) return;
  for (const frame of root.querySelectorAll("iframe[data-src]")) {
    if (frame.getAttribute("src") !== frame.dataset.src) {
      frame.src = frame.dataset.src;
    }
  }
}

/** Any lore overlay closed: blank every lore iframe so nothing keeps running. */
export function stopLoreMedia() {
  for (const root of document.querySelectorAll('[id^="screen-lore-"]')) {
    for (const frame of root.querySelectorAll("iframe")) {
      const src = frame.getAttribute("src");
      if (src && src !== BLANK) frame.src = BLANK;
    }
  }
}
